import React from 'react';
import sanitizeHtml from 'sanitize-html';
import Card from './Card/Card';

export default function Abstract({ abstract }) {
  if (!abstract) return null;

  const safeAbstract = sanitizeHtml(abstract.replace(/\\n/g, '<br />'));

  return (
    <Card title="Abstract">
      <p data-name="content" dangerouslySetInnerHTML={{ __html: safeAbstract }} />
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Abstract.js